import {Button, message, Modal, Space} from 'antd';
import {AuthorizedUserFieldsFragment, useDeleteMasterAccountUserMutation} from 'api/generated';
import {authorizedUsersQuery} from 'api/queries';
import React from 'react';
import {DeleteOutlined} from '@ant-design/icons';
import {useUserContext} from 'hooks/useUserContext';

const {confirm} = Modal;

type Props = {
  user: AuthorizedUserFieldsFragment;
};

export const MasterAccountUserActions: React.FC<Props> = ({user}) => {
  const currentUser = useUserContext();

  const [deleteUser] = useDeleteMasterAccountUserMutation({
    updateQuery: {
      query: authorizedUsersQuery,
      variables: {userEmail: user.userEmail, accountId: user.accountId}
    }
  });

  const handleDelete = () => {
    confirm({
      title: 'Are you sure?',
      okText: 'Delete user',
      okType: 'danger',
      content: (
        <>
          This action will completely delete <b>{user.userEmail}</b> user.
        </>
      ),
      onOk: async () => {
        await deleteUser({
          variables: {
            userEmail: user.userEmail,
            accountId: user.accountId!
          },
          mapResultToUpdate: () => user
        });
        message.success('User deleted successfully.');
      }
    });
  };

  return (
    <>
      {currentUser.userEmail !== user.userEmail && (
        <Space>
          <Button size="small" danger onClick={() => handleDelete()}>
            <DeleteOutlined />
          </Button>
        </Space>
      )}
    </>
  );
};
